export const categories = [
    {
        title: '모델링',
        value: 'MODELING',
    },
    {
        title: '건축',
        value: 'BUILDING',
    },
    {
        title: '엔티티',
        value: 'ENTITY',
    },
    {
        title: '픽셀',
        value: 'PIXEL',
    },
    {
        title: '무료',
        value: 'FREE',
    },
    {
        title: '스크립트',
        value: 'SCRIPT',
    },
    {
        title: '스킨',
        value: 'SKIN',
    },
    {
        title: '스킬',
        value: 'SKILL',
    },
    {
        title: '플러그인',
        value: 'PLUGIN',
    },
];